import { Component, Input, Output, EventEmitter, ViewChildren, QueryList, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent implements OnInit {
  @Input() otpLength: number = 6;
  @Input() isDisabled: boolean = false;
  @Output() otpChange = new EventEmitter<string>();
  @Output() otpComplete = new EventEmitter<string>();
  
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  otpValues: string[] = [];

  ngOnInit() {
    this.otpValues = new Array(this.otpLength).fill('');
  }

  onInputChange(index: number, event: any): void {
    const target = event.target as HTMLInputElement;
    let value = target.value;
    // Solo permitir números


    if (!/^\d*$/.test(value)) {
      target.value = '';
      this.otpValues[index] = '';
      return;
    }

    // Limitar a un solo dígito - tomar el último carácter digitado
    if (value.length > 1) {
      value = value.charAt(value.length - 1);
      target.value = value;
    }

    this.otpValues[index] = value;

    // Emitir cambios
    this.emitOtpChange();

    // Mover al siguiente input si se ingresó un dígito
    if (value && index < this.otpLength - 1) {
      const nextInput = this.otpInputs?.toArray()[index + 1];
      if (nextInput) {
        setTimeout(() => {
          nextInput.nativeElement.focus();
        }, 10);
      }
    }

    // Emitir si está completo
    if (this.isComplete()) {
      this.otpComplete.emit(this.getOtp());
    }
  }

  onKeyDown(index: number, event: KeyboardEvent): void {
    if (event.key === 'Backspace') {
      if (!this.otpValues[index] && index > 0) {
        // Si está vacío y se presiona backspace, ir al anterior
        event.preventDefault();
        this.otpValues[index - 1] = '';
        this.otpInputs.toArray()[index - 1].nativeElement.focus();
        this.emitOtpChange();
      } else if (this.otpValues[index]) {
        // Si tiene valor, permitir que se borre naturalmente y luego limpiar
        setTimeout(() => {
          this.otpValues[index] = '';
          this.emitOtpChange();
        }, 10);
      }
    } else if (event.key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      this.otpInputs.toArray()[index - 1].nativeElement.focus();
    } else if (event.key === 'ArrowRight' && index < this.otpLength - 1) {
      event.preventDefault();
      this.otpInputs.toArray()[index + 1].nativeElement.focus();
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').split('').slice(0, this.otpLength);

  // Limpiar todos los valores primero
  this.otpValues = new Array(this.otpLength).fill('');

    digits.forEach((digit, index) => {
      this.otpValues[index] = digit;
      if (index < this.otpLength - 1) {
        setTimeout(() => {
          const nextInput = this.otpInputs?.toArray()[index + 1];
          if (nextInput) {
            nextInput.nativeElement.focus();
          }
        }, 10 * (index + 1));
      }
    });

    this.emitOtpChange();
    if (this.isComplete()) {
      this.otpComplete.emit(this.getOtp());
    }
  }

  getOtp(): string {
    return this.otpValues.join('');
  }

  isComplete(): boolean {
    return this.otpValues.every(value => value !== '');
  }

  private emitOtpChange(): void {
    this.otpChange.emit(this.getOtp());
  }

  trackByIndex(index: number): number {
    return index;
  }

  clear(): void {
    this.otpValues = new Array(this.otpLength).fill('');
    this.otpInputs.toArray()[0]?.nativeElement.focus();
    this.emitOtpChange();
  }

  focus(): void {
    this.otpInputs.toArray()[0]?.nativeElement.focus();
  }
}
